// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__CKOSW","button":"styles_button__39sXh","buttonText":"styles_buttonText__1EpLL","buttonArrow":"styles_buttonArrow__2XS6y"};